


























































































































































































































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { BoardGettersReturns, BoardActionsKeys, BoardActionsPayload, Board } from '../../store/types/board';
import LogoWhite from '../../assets/logoWhite.svg?inline';
import { ClickOutside } from 'vuetify/lib';
import { RootGettersReturns } from '@/store/types';
import CreateLabel from './Labels/CreateLabel.vue';

@Component({
  components: {
    LogoWhite,
    CreateLabel,
  },
  directives: {
    ClickOutside,
  },
})
export default class BoardList extends Vue {
  @Prop(Boolean) emitSelected?: boolean;
  @Prop(Boolean) shared?: boolean;
  @Prop(Array) boardFilter!: RootGettersReturns['boardFilter'];
  @PropSync('selectedBoard', Number) selectedBoardId!: number | null;

  @Getter boardList!: BoardGettersReturns['boardList'];
  @Getter sharedBoardList!: BoardGettersReturns['sharedBoardList'];
  @Getter favorites!: BoardGettersReturns['favorites'];
  @Getter labels!: BoardGettersReturns['labels'];

  @Action(BoardActionsKeys.CREATE_BOARD) createBoard!: () => Promise<Board>;
  @Action(BoardActionsKeys.DELETE_BOARD) deleteBoard!: (payload: BoardActionsPayload['DELETE_BOARD']) => void;
  @Action(BoardActionsKeys.SHARE_BOARD) shareBoard!: (payload: BoardActionsPayload['SHARE_BOARD']) => Promise<string>;
  @Action(BoardActionsKeys.UNSHARE_BOARD) unshareBoard!: (
    payload: BoardActionsPayload['UNSHARE_BOARD']
  ) => Promise<string>;
  @Action(BoardActionsKeys.REMOVE_SHARED_BOARD) removeSharedBoard!: (
    payload: BoardActionsPayload['REMOVE_SHARED_BOARD']
  ) => Promise<string>;
  @Action(BoardActionsKeys.DUPLICATE_BOARD) duplicateBoard!: (payload: BoardActionsPayload['DUPLICATE_BOARD']) => void;
  @Action(BoardActionsKeys.OPEN_BOARD) openBoard!: (payload: BoardActionsPayload['OPEN_BOARD']) => Promise<void>;
  @Action(BoardActionsKeys.SET_FAVORITE) setFavorite!: (payload: BoardActionsPayload['SET_FAVORITE']) => void;
  @Action(BoardActionsKeys.APPLY_LABEL) applyLabel!: (payload: BoardActionsPayload['APPLY_LABEL']) => Promise<void>;

  deleteBoardModal: false = false;

  hoverBoard: number | null = null;
  openMenu = false;
  snackbar = false;
  snackbarText = '';
  snackbarType = 'success';
  labelSearch = '';
  openLabelMenu = false;
  openLabelMenuId = -1;
  sortingAsc = false;

  get boardsWithFavorites() {
    let useBoards = this.shared ? this.sharedBoardList : this.boardList;
    if (this.boardFilter.length) {
      useBoards = useBoards.filter(b => b.labels.map(l => l.id).some(l => this.boardFilter.includes(l)));
    }

    useBoards = useBoards.sort((a, b) => {
      const x = new Date(a.createdAt).getTime();
      const y = new Date(b.createdAt).getTime();
      return this.sortingAsc ? x - y : y - x;
    });
    return useBoards;
  }

  get visibleLabels() {
    return this.labels.filter(label => label.name.toLowerCase().includes(this.labelSearch.toLowerCase()));
  }

  openMenuForLabel(value: boolean, id: number) {
    this.openLabelMenu = value;
    this.openLabelMenuId = id;

    if (!this.openLabelMenu) {
      this.labelSearch = '';
    }
  }

  async updateLabels(labelsIds: number[], board: Board) {
    const newLabels = labelsIds.filter(labelId => !board.labels.map(l => l.id).includes(labelId));
    const removedLabels = this.visibleLabels.map(l => l.id).filter(labelId => !labelsIds.includes(labelId));
    newLabels.forEach(async labelId => {
      await this.applyLabel({
        labelId,
        boardId: board.id,
        active: true,
      });
    });
    removedLabels.forEach(async labelId => {
      await this.applyLabel({
        labelId,
        boardId: board.id,
        active: false,
      });
    });
  }

  async createNewBoard() {
    const board = await this.createBoard();
    await this.openBoard({ id: board.id });
  }

  selectBoard(boardId: number | null) {
    this.selectedBoardId = boardId;
    this.openMenu = false;
  }

  async share(boardId: number, name: string) {
    const uuid = await this.shareBoard(boardId);
    const success = await this.copyLocation(uuid);
    if (success) {
      setTimeout(() => {
        window.open(
          `${process.env.VUE_APP_COMMUNICATOR_URL}/?body=${btoa(uuid)}&link=${btoa(
            this.buildLocation(uuid)
          )}&title=${btoa(name)}`,
          '_blank'
        );
      }, 1000);
    }
  }

  buildLocation(uuid: string) {
    const location = window.location.origin;
    return `${location}/accept_board/${uuid}`;
  }

  async copyLocation(uuid: string) {
    return this.copy(this.buildLocation(uuid), 'Shared board URL');
  }

  async copy(text: string, type: string) {
    try {
      await navigator.clipboard.writeText(text);
      this.snackbarText = `${type} is copied to clipboard, Communicator will open in 1 second`;
      this.snackbarType = 'success';
      this.snackbar = true;
      return true;
    } catch (e) {
      const textArea = document.createElement('textarea');
      textArea.classList.add('textarea');

      textArea.value = text;
      textArea.textContent = text;

      document.body.appendChild(textArea);

      const selection = document.getSelection();
      const range = document.createRange();
      range.selectNode(textArea);
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
        try {
          document.execCommand('copy');
          selection.removeAllRanges();
          this.snackbarText = `${type} is copied to clipboard, Communicator will open in 3 seconds`;
          this.snackbarType = 'success';
          this.snackbar = true;
          document.body.removeChild(textArea);
          return true;
        } catch (err) {
          this.snackbarText = `Oops, unable to copy ${type}`;
          this.snackbarType = 'error';
          this.snackbar = true;
          document.body.removeChild(textArea);
          return false;
        }
      }

      document.body.removeChild(textArea);
      return true;
    }
  }

  clickOutside = {
    handler: () => {
      this.selectBoard(null);
    },
    closeConditional: (e: MouseEvent) => {
      if (
        e.target &&
        ((e.target as HTMLElement).closest('.inside') ||
          (e.target as HTMLElement).classList.contains('v-overlay__scrim'))
      )
        return false;
      return true;
    },
    include: () => {
      return (this.$refs.card as Vue[]).map(e => e.$el);
    },
  };
}
